import setBizBarUpsellState from './mutators/setBizBarUpsellState';
import { makeArcCall } from './service/makeArcCalls';
import { isFeatureEnabled } from 'owa-feature-flags';
const PLACEMENT_ID = '88000453';

export default async function initializeUpsellBarState() {
    if (isFeatureEnabled('edge-iris-upsell-experiment')) {
        let bizBarIrisDetails = await makeArcCall(PLACEMENT_ID, '&OPSYS=WIN10&browser=2');
        if (bizBarIrisDetails) {
            setBizBarUpsellState(bizBarIrisDetails);
        }
    }
}
